<template>
    <div class="waitPay">
        <date-picker :date.sync="query.date" type="year-month" title="选择年月">
            <template #left>
                <van-checkbox v-model="checkAll" @click="checkAllChange"><span style="color: #009af3">全选</span></van-checkbox>
            </template>
        </date-picker>
        <div class="waitPay-content">
            <lazy-load-list ref="lazyLoadList" :getData="initData" :description="'暂无欠缴账单'" :query="query">
                <template v-slot="slotData">
                    <van-checkbox-group v-model="result" ref="waitPayCheckbox" @change="waitPayitemChange">
                        <van-checkbox :name="item" v-for="(item, index) in slotData.dataList" :key="index">
                            <template #default>
                                <div class="waitPay-content-item-wrap flex-column justify-around">
                                    <div class="waitPay-content-item flex align-center">
                                        <img class="waitPay-content-item1" src="@/assets/images/pay/parkingPay-long.png" alt="" />
                                        <p class="waitPay-content-item-title">计时开始</p>
                                        <p class="waitPay-content-item-value">{{ item.inTime }}</p>
                                    </div>
                                    <div class="waitPay-content-item flex align-center">
                                        <img class="waitPay-content-item1" src="@/assets/images/pay/parking-time.png" alt="" />
                                        <p class="waitPay-content-item-title">停车时长</p>
                                        <p class="waitPay-content-item-value">{{ secondToMinute(item.parkTime) }}分钟</p>
                                    </div>
                                    <div class="waitPay-content-item flex align-center">
                                        <img class="waitPay-content-item1" src="@/assets/images/pay/parkingPay-number.png" alt="" />
                                        <p class="waitPay-content-item-title">泊位号</p>
                                        <p class="waitPay-content-item-value">{{ item.stallCode }}</p>
                                    </div>
                                    <div class="waitPay-content-item flex align-center">
                                        <img class="waitPay-content-item1" src="@/assets/images/pay/parkingPay-code.png" alt="" />
                                        <p class="waitPay-content-item-title">车牌号</p>
                                        <p class="waitPay-content-item-value">{{ item.plateNum }}</p>
                                    </div>
                                    <div class="waitPay-item-money text-price">{{ item.waitPay }}</div>
                                </div>
                            </template>
                        </van-checkbox>
                    </van-checkbox-group>
                </template>
            </lazy-load-list>
        </div>
        <!-- 底部缴费按钮 -->
        <div class="waitPay-comfirm flex align-center">
            <span>已选欠费</span>
            <span class="text-price waitPay-comfirm-money">{{ checkMoney }}</span>
            <van-button :disabled="!checkMoney" class="waitPay-comfirm-btn" color="#009AF3 " v-debounce="comfirmPay">一键补缴</van-button>
        </div>
        <pay-dialog :show.sync="payShow" :arrearList="arrearsDTOs" :AllMoney="checkMoney" />
    </div>
</template>

<script>
import { payList, submitOneKeyPay } from "@/api/index";
import { secondToMinute, one2two } from "@/libs/tools";
import DatePicker from "@/components/base/datePicker/date-picker.vue";
import PayDialog from "@/components/pay/payDialog.vue";
import LazyLoadList from "@/components/base/lazyLoadList/lazy-load-list.vue";

export default {
    name: "WaitPay",
    components: {
        DatePicker,
        PayDialog,
        LazyLoadList,
    },
    data() {
        return {
            checkAll: false,
            result: [],
            payShow: false, //支付方式选择flag
            waitPayList: [], //待支付订单
            query: {
                date: "", //查询时间
                page: 0, //页码
                pageSize: 10, //每页显示个数
                status: "1",
            },
            showDatePick: false,
        };
    },
    computed: {
        checkMoney() {
            if (this.result.length > 0) {
                let money = 0;
                for (let e of this.result) {
                    money = parseFloat((money + +e.consume).toFixed(10));
                }
                return money;
            } else {
                return 0;
            }
        },
        //计算要缴费的停车记录数组
        arrearsDTOs() {
            let array = [];
            if (this.result.length > 0) {
                for (let e of this.result) {
                    let item = {
                        parkTime: e.parkTime, //停车时长 秒
                        parkingrecordid: e.parkingRecordId, //停车记录id
                        payMoney: e.waitPay, //停车费用
                        plateNum: e.plateNum, //车牌号
                        stallCode: e.stallCode, //泊位号
                    };
                    array.push(item);
                }
            }
            return array;
        },

        // dataList() {
        //     return this.$refs.lazyLoadList ? this.$refs.lazyLoadList.list : [];
        // },
    },
    mounted() {},
    // watch: {
    //     "$refs.lazyLoadList": {
    //         handler(newV, oldV) {
    //             debugger;

    //             console.log(newV);
    //             console.log(oldV);
    //         },
    //         deep: true,
    //     },
    // },
    methods: {
        secondToMinute,
        //给子组件使用
        initData() {
            return payList(this.query);
        },
        changeShow() {},
        //确认支付
        comfirmPay() {
            this.payShow = true;
            // console.log(this.result);

            // let obj = {
            //     arrearsDTOs: this.arrearsDTOs,
            //     goodDetail: "停车缴费", //商品详情
            //     goodSubject: "停车缴费", //商品标题
            //     merchants: "BESTPAY", //默认传BESTPAY  用余额支付时  传WALLETPAY
            //     orderMoney: this.checkMoney, //订单总金额
            //     payChannel: "TENPAY", //TENPAY 微信支付
            // };
            // submitOneKeyPay(obj).then((res) => {
            //     if (res.code == 200) {
            //         window.location.href = res.data.data.payUrl;
            //     }
            // });
        },

        // 复选框组修改事件
        waitPayitemChange() {
            if (this.result.length == this.$refs.lazyLoadList.list.length) {
                this.checkAll = true;
            } else {
                this.checkAll = false;
            }
        },

        //全选函数
        checkAllChange(value) {
            this.$refs.waitPayCheckbox.toggleAll(this.checkAll);
        },
    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/color.less";

.waitPay {
    min-height: 100vh;

    .waitPay-header {
        width: 750px;
        height: 90px;
        padding: 30px;
        position: fixed;
        top: 0;
        left: 0;
        background-color: #fff;
        z-index: 99;

        .waitPay-date {
            font-size: 28px;
            color: #666666;

            i {
                margin: 0 4px;
            }
        }
    }

    .waitPay-content {
        padding: 100px 24px 150px 24px;

        .waitPay-content-item-wrap {
            width: 648px;
            height: 320px;
            border-radius: 16px;
            background-color: #fff;
            padding: 30px;
            margin-bottom: 16px;

            .waitPay-content-item {
                .waitPay-content-item1 {
                    width: 24px;
                    height: 24px;
                }

                .waitPay-content-item-title {
                    margin-left: 17px;
                    vertical-align: top;
                }

                .waitPay-content-item-value {
                    margin-left: auto;
                    color: #666666;
                }
            }

            .waitPay-item-money {
                color: #009af3;
                border-top: 1px solid #dbdada;
                text-align: right;
                font-size: 50px;
                padding-top: 16px;
            }
        }
    }

    .waitPay-comfirm {
        width: 750px;
        height: 124px;
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #fff;
        justify-content: flex-end;
        padding: 24px;

        .waitPay-comfirm-money {
            margin: 0 18px;
            color: @main-color;
            font-size: 50px;
        }

        .waitPay-comfirm-btn {
            width: 200px;
            height: 72px;
            color: #fff;
            font-size: 34px;
            border-radius: 16px;
        }
    }
}
</style>
